import { useUtilityContext } from "@Context/prompt-toolbox/UtilityContext";

interface Props {
  onAdd: () => void;
}

const AddPrompt: React.FC<Props> = ({ onAdd }) => {
  const { setModal } = useUtilityContext();

  return (
    <div>
      <span className="flex flex-col gap-y-10">
        <label data-testid="new-prompt-modal">This will add a new prompt.</label>
        <span className="flex flex-row items-center justify-end gap-x-2">
          <button data-testid="new-prompt-modal-add-button"
            onClick={onAdd}
            className="rounded-md bg-primary-700 px-4 py-2 text-white"
          >
            Add
          </button>
          <button data-testid="new-prompt-modal-cancel-button"
            onClick={() => setModal("addPrompt", false)}
            className="rounded-md bg-brandRed-300 px-4 py-2 text-white"
          >
            Cancel
          </button>
        </span>
      </span>
    </div>
  );
};

export default AddPrompt;
